/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import ModalBaseLayout from '../ModalBaseLayout';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {createForm} from 'rc-form';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionRouteNavigate} from '../../../store/actions/actions-route';
import {ActionChangePassword} from '../../../store/actions/actions-user';
import {CloseIcon} from '../../SvgComponents/SvgComponents';
import {getRandomPassword} from '../../../services/common';
import {NotificationSuccess} from '../../../services/notifications';

class ModalChangePassword extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center change-pass-popup',
      closeButton: true,
      keyboard: true,
    });

    this.state = {
      showNewPassword: false,
      showConfirmPassword: false,
      sendEmail: true,
      generatedPassword: '',
    };
  }

  onCloseClick = () => {
    this.props.ActionModalHide();
  };

  generatetRandomPassword = () => {
    const randomPassword = getRandomPassword();

    this.props.form.setFieldsValue({
      newPassword: randomPassword,
      confirmNewPassword: randomPassword,
      generatedPassword: randomPassword,
    });
    this.setState({generatedPassword: randomPassword});
  };

  onChangeState = (value, type) => {
    this.setState({
      [type]: value,
    });
  };

  changePassword = (e) => {
    e.preventDefault();
    this.props.form.validateFields((error, values) => {
      if (!error) {
        this.props.ActionChangePassword({
          password: values.oldPassword,
          newPassword: values.newPassword,
          sendEmail: this.state.sendEmail,
        });
      }
    });
  };

  checkPass = (rule, value, callback) => {
    if (!value) {
      callback([new Error('Confirm password is required')]);
    } else if (this.props.form.getFieldValue('newPassword') !== value) {
      callback([new Error('Confirm password is mismatch with password')]);
    } else {
      callback();
    }
  };

  copyPassword = () => {
    const {generatedPassword} = this.state;
    if (generatedPassword) {
      navigator.clipboard.writeText(generatedPassword).then(() => {
        NotificationSuccess('Пароль скопирован', null, 2000);
      }, (err) => {
        console.error('Could not copy text: ', err);
      });
    }
  };

  render() {
    const {showNewPassword, showConfirmPassword, sendEmail} = this.state;
    const {loading} = this.props;
    let errors;
    const {getFieldProps, getFieldError} = this.props.form;
    const getErrorByFieldName = (fieldType) => (errors = getFieldError(fieldType));

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-header">
            <h3 className="modal-header_title">Сменить пароль</h3>
            <button className="modal-close-btn" onClick={this.onCloseClick}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal-content">
            <div className="change-pass-form">
              <div className="row align-centr change-pass_row">
                <div className="col-md-4 col-12">
                  <label className="change-pass_label">Введите старый пароль</label>
                </div>
                <div className="col-md-8 col-12">
                  <input
                    id="oldPassword"
                    className={`${getErrorByFieldName('oldPassword') ? 'error' : ''}`}
                    placeholder="Введите старый пароль"
                    type="password"
                    {...getFieldProps('oldPassword', {
                      rules: [{required: true}],
                    })
                    }
                  />
                </div>
              </div>
              <div className="row align-centr change-pass_row">
                <div className="col-md-4 col-12">
                  <label className="change-pass_label">Придумайте новый пароль</label>
                </div>
                <div className="col-md-8 col-12">
                  <div className="change-pass_input-wrap">
                    <input
                      id="newPassword"
                      placeholder="Введите новый пароль"
                      type={`${showNewPassword ? 'text' : 'password'}`}
                      className={`${getErrorByFieldName('newPassword') ? 'error' : ''}`}
                      {...getFieldProps('newPassword', {
                        rules: [{required: true}],
                      })
                      }
                    />
                    <button
                      className={`btn-show-password ${showNewPassword ? 'open' : ''}`}
                      onClick={() => this.onChangeState(!showNewPassword, 'showNewPassword')}
                    />
                  </div>
                </div>
              </div>
              <div className="row align-centr change-pass_row">
                <div className="col-md-4 col-12">
                  <label className="change-pass_label">Повторите новый пароль</label>
                </div>
                <div className="col-md-8 col-12">
                  <div className="change-pass_input-wrap">
                    <input
                      id="confirmNewPassword"
                      placeholder="Введите новый пароль"
                      className={`${getErrorByFieldName('confirmNewPassword') ? 'error' : ''}`}
                      type={`${showConfirmPassword ? 'text' : 'password'}`}
                      {...getFieldProps('confirmNewPassword', {
                        validateTrigger: 'onBlur',
                        rules: [{
                          validator: this.checkPass,
                        }],
                      })
                      }
                    />
                    <button
                      className={`btn-show-password ${showConfirmPassword ? 'open' : ''}`}
                      onClick={() => this.onChangeState(!showConfirmPassword, 'showConfirmPassword')}
                    />
                  </div>
                </div>
              </div>
              <div className="row change-pass_row">
                <div className="col-12  text-center">
                  <label className="change-pass_label">или</label>
                </div>
              </div>
              <div className="row align-centr change-pass_row">
                <div className="col-md-4 col-12">
                  <div className="change-pass_label change-pass_generate" onClick={this.generatetRandomPassword}>Сгенерировать пароль</div>
                </div>
                <div className="col-md-8 col-12">
                  <div className="change-pass_input-wrap input-copy-wrap">
                    <input
                      type="text"
                      readOnly
                      value={this.state.generatedPassword}
                      onChange={(event) => this.onChangeState(event.target.value, 'generatedPassword')}
                    />
                    <div className="change-pass_btn-show" />
                    <span className="copy shift-left" onClick={this.copyPassword} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8 col-12 offset-md-4">
                  <div className="checkbox">
                    <input
                      type="checkbox"
                      id="checkbox"
                      checked={sendEmail}
                      onChange={(e) => this.onChangeState(e.target.checked, 'sendEmail')}
                    />
                    <label htmlFor="checkbox" className="input-label">Выслать пароль на электронную почту</label>
                  </div>
                </div>
              </div>
              <div className="change-pass-row">
                <div className="btn-wrap">
                  <button
                    className={`btn btn-base ${loading ? 'btn-loading' : ''}`}
                    onClick={this.changePassword}
                  >
                    {loading ? 'Сохранение...' : 'Сохранить'}
                    {loading ? <span className="loading-circle" /> : null}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalChangePassword.propTypes = {};

function mapStateToProps({rLoading}) {
  return {
    loading: rLoading.changePasswordLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionRouteNavigate,
    ActionChangePassword,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(createForm()(ModalChangePassword));
